module.exports = __webpack_public_path__ + "img/card3.c7296029.png";